module.exports = __webpack_public_path__ + "img/activity.45856c82.svg";